
import ItemInfo from '../ItemInfo/ItemInfo';

const Professions = ({ id }) => {

	const modalTexts = {
		"Java": 'Небольшое описание в несколько строк о специальности',
		"React": 'Небольшое описание в несколько строк о специальности',
		"Sys": 'Небольшое описание в несколько строк о специальности',
		"QA": 'Небольшое описание в несколько строк о специальности'
	}

	const ident = id;

	return (
		<div id={ident} className="main__professions professions-main">
			<div className="professions-main__body">
				<h2 className="professions-main__title _title">Профессии</h2>
				<div className="professions-main__items">
					<ItemInfo
						image='assets/images/mainPage/professions/proff-img-1.png'
						title='Java разработчик'
						description='Небольшое описание в несколько строк о специальности'
						isHasButton={true}
						modalText={modalTexts.Java}
					/>
					<ItemInfo
						image='assets/images/mainPage/professions/proff-img-2.png'
						title='React разработчик'
						description='Небольшое описание в несколько строк о специальности'
						isHasButton={true}
						modalText={modalTexts.React}
					/>
					<ItemInfo
						image='assets/images/mainPage/professions/proff-img-3.png'
						title='Системный аналитик'
						description='Небольшое описание в несколько строк о специальности'
						isHasButton={true}
						modalText={modalTexts.Sys}
					/>
					<ItemInfo
						image='assets/images/mainPage/professions/proff-img-4.png'
						title='QA - тестировщик'
						description='Небольшое описание в несколько строк о специальности'
						isHasButton={true}
						modalText={modalTexts.QA}
					/>
				</div>
			</div>
		</div>
	)

}

export default Professions;